import React from 'react';

const Navbar = () => {
  return (
    <nav className="bg-black text-white p-4 flex justify-between items-center">
      <div className="flex items-center">

        <a href='https://illinoisanswers.org/'><img src="https://i0.wp.com/illinoisanswers.org/wp-content/uploads/2022/10/cropped-iap-logo-2.png?w=497&ssl=1" alt="Illinois Answers" className=" w-2/6" />
</a>
      </div>
      <a href='https://illinoisanswers.org/about/donate/'>
      <button className=" text-white px-4 py-2 rounded">
        Donate
      </button>
      </a>

    </nav>
  );
};

export default Navbar;